import React from "react";
import { Button } from "antd";
import MarkModal from "../../../supervise/components/SuperviseTable/component/MarkModal";
import useModalHandler from "utils/useModalHandler";
import useRequestFn from "utils/useRequestFn";
import { getExamFlagList } from "service/exam";
import { ResultMessage } from "components/ResultMessage";
import { errorMessage } from "service/service";
import styles from "./index.module.scss";

interface ButtonMarkErrorProps {
    examId: string;
    stuNo: string;
    onChange(): void;
}

export function ButtonMarkError({
    examId,
    stuNo,
    onChange
}: ButtonMarkErrorProps) {
    const markModal = useModalHandler();

    const [getFlagList, { loading: flagListLoading, data: flagList }] =
        useRequestFn(getExamFlagList);

    //获取标记列表
    const updateFlagList = async (param?: string) => {
        const studentNo = param ? param : stuNo;
        try {
            await getFlagList(studentNo, examId);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    function markError() {
        updateFlagList(stuNo);
        markModal.open();
    }

    return (
        <>
            <Button className={styles.button} type="link" onClick={markError}>
                标记异常
            </Button>

            <MarkModal
                visible={markModal.visible}
                onCancel={markModal.close}
                examId={examId}
                stuNo={stuNo}
                flagList={flagList}
                loading={flagListLoading}
                updateData={updateFlagList}
                updateSuperviseData={onChange}
            />
        </>
    );
}
